import { Fragment, useState, useEffect, useRef, useCallback } from "react";

import {
  CircularProgress,
  Grid2 as Grid,
  Tooltip,
  Zoom,
  IconButton,
  Autocomplete,
  TextField,
  Box,
} from "@mui/material";
import * as XLSX from "xlsx";
import { Delete, Notifications } from "@mui/icons-material";
import EnhancedTable from "../../components/BTTable";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import authService from "../../services/auth-service";
import BTDialogBox from "../../components/BTDialgBox";
import BTInput from "../../components/BTInput";
import BTBox from "../../components/BTBox";
import BTButton from "../../components/BTButton";
import BTLoader from "../../components/BTLoader";
import { Error } from "@mui/icons-material";
import { useLoading, useNotification } from "../../context";
import { useDispatch } from "react-redux";
import { batchUpdate } from "../../store/labSlice";
const filterOptions = [
  { value: "all", label: "All" },
  { value: "verified", label: "Verified" },
  { value: "unverified", label: "Unverified" },
];
const Addreplied = ({ open, setOpen, type }) => {
  const { u_id, u_type, admin_u_id } = secureLocalStorage.getItem("userdata");
  const dispatch = useDispatch();
  const initialState = {
    replies: {
      stn_id: null,
      admin_u_id: u_type === 1 ? u_id : admin_u_id,
      p_id: null,
      document_no: null,
      report_date: null,
      report_number: null,
      prefix: null,
      other_report_number: null,
      shape_name: null,
      weight: null,
      number_stones: null,
      description: null,
      measurement1: null,
      measurement2: null,
      measurement3: null,
      table: null,
      crown_height: null,
      pavilion_depth: null,
      total_depth: null,
      crown_angle: null,
      pavilion_angle: null,
      culet_size: null,
      girdle_percent: null,
      girdle_name: null,
      pol_or_pol_sym: null,
      sym: null,
      cut_prop: null,
      clarity: null,
      color_long: null,
      report_type_i: null,
      report_format_i: null,
      color_short: null,
      report_type_ii: null,
      report_format_ii: null,
      fluorescence: null,
      comments_consultation: null,
      special_comments: null,
      report_comment: null,
      customer_ref_no: null,
      memo_no: null,
      fax_comments: null,
      laserscribe: null,
      recheck: null,
      key_to_symbols: null,
      lp: null,
      rep_desc: null,
      rep_deleted: null,
      rep_date: moment().format("YYYY-MM-DD"),
      rep_type: 1,
      sub_replies: [],
      rep_created_by: u_id,
      rep_updated_by: u_id,
    },
  };
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(filterOptions[0]);
  const { addNotification } = useNotification();
  const { showLoading, hideLoading } = useLoading();

  const sub_count =
    formData?.replies?.sub_replies?.reduce(
      (total, item) => total + (Number(item?.number_stones) || 0),
      0
    ) || 0;
  const sub_weight =
    formData?.replies.sub_replies?.reduce(
      (total, item) => total + (Number(item?.weight) || 0),
      0
    ) || 0;

  const handleClose = () => {
    setOpen(null);
  };

  const sharedFieldsConfig = [
    {
      name: "rep_date",
      label: "Date",
      type: "date",
      required: true,
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      replies: {
        ...prev.replies,
        [name]: value,
      },
    }));
  };

  const handleUpload = () => {
    fileInputRef.current.click();
  };

  const handleFilterChange = (event, newValue) => {
    setFilter(newValue);
  };

  const submitReplies = async (e) => {
    e.preventDefault();
    const finalFormData = {
      replies: {
        ...formData?.replies,
        number_stones: +sub_count,
        weight: +sub_weight?.toFixed(2),
      },
    };
    const deleteRec = formData?.replies.sub_replies?.filter(
      ({ rep_deleted }) => rep_deleted
    );
    try {
      setLoading(true);
      const response = await authService?.insert_reply({
        attributes: {
          replies: { ...finalFormData.replies, final_submit: true },
        },
      });
      if (response?.status && response?.status_code === 200) {
        const { replies, submits, ...data } = response?.data;

        const updateRec = type ? replies : [data];
        dispatch(
          batchUpdate({
            name: "submission",
            key: "stn_id",
            insert: [],
            updateItems: submits,
            removeItems: [],
          })
        );
        dispatch(
          batchUpdate({
            name: "reply",
            key: "rep_id",
            insert: updateRec,
            updateItems: [],
            removeItems: deleteRec,
          })
        );
        addNotification({
          icon: <Notifications color="white" />,
          title: "Success!",
          message: response?.message,
          color: "success",
        });
        handleClose();
      }
    } catch (error) {
      addNotification({
        icon: <Error color="white" />,
        title: "Error!",
        message: "Failed to submit replies",
        color: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const renderField = (field, onChange, record) => {
    if (field.name === "rep_date") {
      return (
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <BTInput
            name={field.name}
            label={field.label}
            type={field.type || "text"}
            value={record[field.name] || ""}
            onChange={onChange}
            variant="standard"
            required={field.required}
            fullWidth
            {...field.props}
          />
          <Autocomplete
            options={filterOptions}
            getOptionLabel={(option) => option.label}
            disableClearable
            value={filter}
            onChange={handleFilterChange}
            sx={{ width: "300px" }}
            renderInput={(params) => (
              <TextField {...params} label="Filter" variant="standard" />
            )}
          />
        </Box>
      );
    }
    return (
      <BTInput
        name={field.name}
        label={field.label}
        type={field.type || "text"}
        value={record[field.name] || ""}
        onChange={onChange}
        variant="standard"
        required={field.required}
        fullWidth
        {...field.props}
      />
    );
  };

  const updateDates = useCallback((date) => {
    setFormData((prev) => {
      // Update main reply and sub_replies dates
      const updatedReplies = {
        ...prev.replies,
        rep_date: date,
        sub_replies: prev.replies.sub_replies.map((subReply) => ({
          ...subReply,
          rep_date: date,
        })),
      };

      // Update submits services dates (only for new services)
      // const updatedSubmits = prev.submits.map((submit) => {
      //   const updatedServices = submit.stn_services?.map((service) => {
      //     if (!service.ser_status) {
      //       return { ...service, ser_date: date };
      //     }
      //     return service;
      //   });
      //   return { ...submit, stn_services: updatedServices };
      // });

      return {
        replies: updatedReplies,
        // submits: updatedSubmits,
      };
    });
  }, []);

  useEffect(() => {
    if (formData.replies.rep_date) {
      updateDates(formData.replies.rep_date);
    }
  }, [formData.replies.rep_date, updateDates]);

  const handleDeleteRow = (rowOrRows) => {
    setFormData((prev) => {
      const rowsToDelete = Array.isArray(rowOrRows) ? rowOrRows : [rowOrRows];
      const refNosToDelete = new Set(
        rowsToDelete.map((row) => row?.customer_ref_no)
      );

      return {
        replies: {
          ...prev.replies,
          sub_replies: prev.replies.sub_replies.filter(
            (item) => !refNosToDelete.has(item?.customer_ref_no)
          ),
        },
        // submits: prev.submits.filter(
        //   (item) => !refNosToDelete.has(item?.customer_ref_no)
        // ),
      };
    });
  };

  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (!selectedFiles.length) return;

    try {
      showLoading();
      // Initialize accumulators for all files
      let repliesData = [];
      let isValid = false;

      // Process each file sequentially
      for (const selectedFile of selectedFiles) {
        const fileResult = await processSingleFile(selectedFile);
        if (fileResult.error) {
          isValid = true;
          addNotification({
            icon: <Error color="white" />,
            title: "Invalid File!",
            message: fileResult.error,
            color: "error",
          });
          continue; // Skip to next file
        }
        repliesData = [...repliesData, ...fileResult.repliesData];
      }
      if (!isValid) {
        try {
          const obj = {
            replies: {
              ...formData.replies,
              sub_replies: repliesData,
              final_submit: false,
            },
          };
          const response = await authService?.insert_reply({
            attributes: obj,
          });
          const isError = response?.status_code === 206;
          const { replies } = response?.data || [];
          setFormData((prev) => ({
            ...prev,
            replies: {
              ...prev.replies,
              sub_replies: replies,
            },
          }));
          addNotification({
            icon: <Notifications color="white" />,
            title: isError ? "Error!" : "Successfully!",
            message: response?.message,
            color: isError ? "warning" : "success",
          });
        } catch (error) {
          addNotification({
            icon: <Error color="white" />,
            title: "Error!",
            message:
              error?.response?.data?.message || "Failed to upload replies",
            color: "error",
          });
        }
      }
    } catch (error) {
      addNotification({
        icon: <Error color="white" />,
        title: "Error!",
        message: "An unexpected error occurred while processing files.",
        color: "error",
      });
    } finally {
      hideLoading();
    }
  };

  // Helper function to process individual file
  const processSingleFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, {
            type: file.name.endsWith(".csv") ? "string" : "binary",
          });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];

          const requiredColumns = [
            "Customer Ref No.",
            "Document No",
            "Report Date",
            "Report Number",
            "Other Report Number",
            "Prefix",
            "Weight",
            "Number Stones",
            "Description",
            "Laserscribe",
            "POL or Pol/Sym",
            "CUT-PROP",
            "Shape Name",
            "SYM",
            "Clarity",
            "Fluorescence",
            "Key To Symbols",
            "Table",
            "Measurement1",
            "Measurement2",
            "Measurement3",
            "Crown Height",
            "Pavilion Depth",
            "Total Depth",
            "Crown Angle",
            "Pavilion Angle",
            "Culet Size",
            "Girdle Percent",
            "Girdle Name",
            "Color (Long)",
            "Color (Short)",
            "Report Comment",
            "Memo No",
            "Fax Comments",
            "Comments Consultation",
            "Special Comments",
            "Report Comment",
            "Report Type I",
            "Report Format I",
            "Report Type II",
            "Report Format II",
            "Recheck",
            "LP",
          ];

          // Validate file structure
          const range = XLSX.utils.decode_range(worksheet["!ref"]);
          const actualColumns = [];
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = { c: C, r: 0 };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            actualColumns.push(worksheet[cellRef]?.v.trim());
          }

          const missingColumns = requiredColumns.filter(
            (col) => !actualColumns.includes(col)
          );

          if (missingColumns.length > 0) {
            return resolve({
              error: `Missing columns in ${file.name}: ${missingColumns.join(
                ", "
              )}`,
              repliesData: [],
              submitsData: [],
            });
          }

          const jsonResult = XLSX.utils
            .sheet_to_json(worksheet, {
              defval: "",
            })
            .map((item) => {
              const newItem = {};
              for (const key in item) {
                const newKey = key.trim();
                newItem[newKey] = item[key];
              }
              return newItem;
            });

          const repliesData = jsonResult.map((item) => {
            return {
              admin_u_id: u_type === 1 ? u_id : admin_u_id,
              rep_type: 2,
              document_no: item["Document No"],
              report_date: item["Report Date"],
              report_number: item["Report Number"],
              prefix: item["Prefix"],
              other_report_number: item["Other Report Number"],
              shape_name: item["Shape Name"],
              weight: item["Weight"],
              number_stones: item["Number Stones"],
              description: item["Description"],
              measurement1: item["Measurement1"],
              measurement2: item["Measurement2"],
              measurement3: item["Measurement3"],
              table: item["Table"],
              crown_height: item["Crown Height"],
              pavilion_depth: item["Pavilion Depth"],
              total_depth: item["Total Depth"],
              crown_angle: item["Crown Angle"],
              pavilion_angle: item["Pavilion Angle"],
              culet_size: item["Culet Size"],
              girdle_percent: item["Girdle Percent"],
              girdle_name: item["Girdle Name"],
              pol_or_pol_sym: item["POL or Pol/Sym"],
              sym: item["SYM"],
              cut_prop: item["CUT-PROP"],
              clarity: item["Clarity"],
              color_long: item["Color (Long)"],
              report_type_i: item["Report Type I"],
              report_format_i: item["Report Format I"],
              color_short: item["Color (Short)"],
              report_type_ii: item["Report Type II"],
              report_format_ii: item["Report Format II"],
              fluorescence: item["Fluorescence"],
              comments_consultation: item["Comments Consultation"],
              special_comments: item["Special Comments"],
              report_comment: item["Report Comment"],
              customer_ref_no: item["Customer Ref No."],
              memo_no: item["Memo No"],
              fax_comments: item["Fax Comments"],
              laserscribe: item["Laserscribe"],
              recheck: item["Recheck"],
              key_to_symbols: item["Key To Symbols"],
              lp: item["LP"],
              rep_desc: null,
              rep_deleted: null,
              rep_date: formData.replies.rep_date,
              rep_created_by: u_id,
              rep_updated_by: u_id,
              verify: true,
              error_msg: "",
            };
          });

          resolve({
            repliesData,
            error: null,
          });
        } catch (error) {
          resolve({
            error: `Invalid format in ${file.name}: Please upload a valid Excel or CSV file.`,
            repliesData: [],
          });
        }
      };

      reader.onerror = () => {
        resolve({
          error: `Error reading file ${file.name}`,
          repliesData: [],
        });
      };

      if (file.name.endsWith(".csv")) {
        reader.readAsText(file);
      } else {
        reader.readAsBinaryString(file);
      }
    });
  };

  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "report_date",
      name: "Report Date",
      selector: (row) => row.report_date,
      width: "100px",
    },
    {
      id: "report_number",
      name: "Report Number",
      selector: (row) => row.report_number,
      width: "100px",
    },
    {
      id: "shape_name",
      name: "Shape Name",
      selector: (row) => row.shape_name,
      width: "150px",
    },
    {
      id: "weight",
      name: "Weight",
      selector: (row) => row.weight,
      width: "50px",
    },
    {
      id: "description",
      name: "Description",
      selector: (row) => row.description,
      width: "150px",
    },
    {
      id: "pol_or_pol_sym",
      name: "POL or Pol/Sym",
      selector: (row) => row.pol_or_pol_sym,
      width: "150px",
    },
    { id: "sym", name: "SYM", selector: (row) => row.sym, width: "150px" },
    {
      id: "cut_prop",
      name: "CUT-PROP",
      selector: (row) => row.cut_prop,
      width: "150px",
    },
    {
      id: "clarity",
      name: "Clarity",
      selector: (row) => row.clarity,
      width: "150px",
    },
    {
      id: "fluorescence",
      name: "Fluorescence",
      selector: (row) => row.fluorescence,
      width: "150px",
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      width: "100px",
    },
    {
      id: "customer_ref_no",
      name: "Customer Ref No.",
      selector: (row) => row.customer_ref_no,
      width: "150px",
    },
    {
      id: "laserscribe",
      name: "Laserscribe",
      selector: (row) => row.laserscribe,
      width: "150px",
    },
    {
      id: "recheck",
      name: "Recheck",
      selector: (row) => row.recheck,
      width: "300px",
    },
    {
      id: "verified_status",
      name: "Varified status",
      selector: (row) => row?.error_msg,
      width: "200px",
    },
    {
      id: "date",
      name: "Date",
      selector: (row) =>
        moment(row.rep_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY "),
      width: "150px",
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row, index) => (
        <Tooltip title="Delete" TransitionComponent={Zoom}>
          <IconButton size="small" onClick={() => handleDeleteRow(row)}>
            <Delete fontSize="12px" color="error" />
          </IconButton>
        </Tooltip>
      ),
      width: "50px",
      bodyCellStyle: {
        padding: "0px",
      },
    },
  ];

  const filteredResults =
    filter.value === "all"
      ? formData.replies.sub_replies
      : formData.replies.sub_replies.filter((item) =>
          filter.value === "verified" ? item.verify : !item?.verify
        );

  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth={"xll"}
      maxHeight={"500px"}
      minHeight={"500px"}
      onSubmit={submitReplies}
      close={handleClose}
      title={"Add Replies"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: "Submit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          disabled:
            formData.replies.sub_replies?.some((item) => !item.verify) ||
            formData.replies.sub_replies?.length === 0 ||
            loading,
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <BTLoader />
      <Grid container spacing={2}>
        {sharedFieldsConfig.map((field, index) => (
          <Grid size={{ xs: 12, md: 3 }} key={`main-${index}`}>
            {renderField(field, handleChange, formData.replies)}
          </Grid>
        ))}
        <Grid
          size={{ xs: 12, md: 3 }}
          display="flex"
          alignItems="center"
          mt={1}>
          <BTButton
            variant="gradient"
            onClick={handleUpload}
            color="dark"
            size="small"
            sx={{ width: "80px" }}
            fullWidth>
            Upload
          </BTButton>
          <input
            type="file"
            multiple={true}
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: "none" }}
            accept=".xlsx,.xls,.csv"
          />
        </Grid>
      </Grid>
      <BTBox mt={2}>
        <EnhancedTable
          rows={filteredResults}
          columns={columns}
          tableHeader={true}
          checkBoxSelected={true}
          onDeleteSelected={handleDeleteRow}
          pagination={true}
          getRowStyle={(row) => {
            if (!row?.verify) {
              return {
                backgroundColor: "#fbd1d3",
                "&:hover": {
                  backgroundColor: "#d0e9d1",
                },
              };
            } else {
              return {
                backgroundColor: "#ddffdd",
                "&:hover": {
                  backgroundColor: "#d0e9d1",
                },
              };
            }
          }}
        />
      </BTBox>
    </BTDialogBox>
  );
};

export default Addreplied;
